




// document.querySelectorAll("[data-option-selector-js] input").forEach(function(currentElement, index) { 
//     console.log(`Input #${index + 1}:`, currentElement.value); // Log the value of each input
//     // Or add event listeners if needed
//     currentElement.addEventListener('click', function() {
  
//       console.log(`Checkbox #${index + 1} is checked`);
  
  
//         // if (currentElement.type === 'checkbox') {
//         //     // If checkbox is checked, add the 'checked' attribute (or ensure it stays)
//         //     if (currentElement.checked) {
//         //         currentElement.setAttribute('checked', true);
//         //         console.log(`Checkbox #${index + 1} is checked`);
//         //     } else {
//         //         // Remove the 'checked' attribute when the checkbox is unchecked
//         //         currentElement.removeAttribute('checked');
//         //         console.log(`Checkbox #${index + 1} is unchecked`);
//         //     }
//         // }
//         // console.log(`Input #${index + 1} changed to:`, currentElement.value);
//     });
//   });



//   $("[data-option-selector-js] input[name='option1']").on("change", function (e) {
// e.preventDefault();

//     console.log("Input", this.value); 

//   });



//   $(document).ready(function() {
//     $("[data-option-selector-js] input[name='option1']").on("change", function (e) {
//         // e.preventDefault(); // Only use this if you need to prevent default action
//         console.log("Input value:", this.value); // Log the value of the input
        
//         // If it's a checkbox or radio button, check if it's checked
//         if (this.type === 'checkbox') {
//             console.log("Checkbox is", this.checked ? 'checked' : 'unchecked');
//         }
//     });
// });




// function toggleDealTag(deal, soldOut, discount, isChecked) {
//   console.log(deal, soldOut, discount, isChecked)
//   const titleEl = deal.querySelector('.title');
//   if (!titleEl) return null;

//   // Always clear existing tags first
//   titleEl.querySelectorAll('.tag').forEach(tag => tag.remove());

//   let tag = null;

//   if (isChecked) return;

//   if (soldOut) {
//     tag = document.createElement('div');
//     tag.classList.add('tag', 'sold-out', 'svelte-zhxkdj', 'cs-variant-opt');
//     tag.textContent = 'SOLD OUT';
//     titleEl.appendChild(tag);
//   } else if (discount > 0) {
//     tag = document.createElement('div');
//     tag.classList.add('tag', 'svelte-zhxkdj', 'cs-variant-opt');
//     tag.textContent = `${discount}% OFF`;
//     titleEl.appendChild(tag);
//   }

//   return tag;
// }


function handleSwatchClick(e) {
  const label = e.target.closest('label');
  if (!label) return;

  const inputId = label.getAttribute('for');
  const input = document.getElementById(inputId);
  // console.log('e.target', e.target,'label', label, 'input', input);

  // initial soldout based on the is-disabled class, correct logic when variant (color and size) is out of stock
  let isSoldOut = label.classList.contains('is-disabled');

  // when the color is not disabled (one size is available), isSoldOut will not be correct, we need to check if the selected size is available or not
  // the issue is that on load it will use the checked attribute for the input and data-select="is-selected"
  // but when changing variants is uses the active class so checking for either will give incorrect outcome
  // when the user changes between variants (colors) since the size is not re-rendered
  // will get the label.active first and if it's null check for data-select="is-selected"
  // delay the size check to allow class updates to apply
  
  setTimeout(() => {
    const sizeFieldset = document.querySelector('[data-wair-option-name="SIZE"]');
    if (sizeFieldset) {
      const activeSize = sizeFieldset.querySelector('label.active');
      let selectedSize = null;

      if (activeSize) {
        if (activeSize.classList.contains('is-disabled')) {
          isSoldOut = true;
        }
      } else {
        selectedSize = sizeFieldset.querySelector('[data-select="is-selected"]');
        if (selectedSize && selectedSize.classList.contains('is-disabled')) {
          isSoldOut = true;
        }
      }

      toggleSoldOut(isSoldOut);
    }
  }, 0);

  const value = input.value?.toLowerCase();
  if (!value) return;

  const dealHost = document.querySelector('adoric-bundle-mark-one');
  const dealsContent = dealHost?.shadowRoot?.querySelector('.deals-content');
  if (!dealsContent) return;

  const activeDeal = dealsContent.querySelector('[data-checked="true"]');
  if (!activeDeal) return;

  const selects = activeDeal.querySelectorAll('select');
  selects.forEach(select => {
    const matchOption = Array.from(select.options).find(opt => opt.textContent.trim().toLowerCase() === value);
    if (matchOption) {
      select.value = matchOption.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

function toggleSoldOut(soldOut) {
  // get the shadowroot  and then the parent node of all deals
  const dealHost = document.querySelector('adoric-bundle-mark-one');
  const dealsContent = dealHost?.shadowRoot?.querySelector('.deals-content');
  if (!dealsContent) return;

  // loop over them and change the data-sold-out attribute
  dealsContent.querySelectorAll('.deal-content').forEach(deal => {
    deal.setAttribute('data-sold-out', soldOut);
    const isChecked = deal.getAttribute('data-checked') === 'true';


    const price = deal.querySelector('.price');
    const initialPrice = deal.querySelector('.initial-price');


    if (initialPrice && price) {
      // this means we have a discount
      const initialPriceText = initialPrice.textContent.split(' ')[0];
      const priceText = price.textContent.split(' ')[0];
      const discount = initialPriceText - priceText;
      const discountPercent = Math.ceil((discount / initialPriceText) * 100);
      
      toggleDealTag(deal,soldOut, discountPercent, isChecked);
    } else if (price) {
      // no discount deal
      toggleDealTag(deal,soldOut, 0, isChecked);
    }
  });  
}

function toggleDealTag(deal, soldOut, discount, isChecked) {
  const titleEl = deal.querySelector('.title');
  if (!titleEl) return null;

  const existingTag = titleEl.querySelector('.tag');

  removeDuplicateTags(deal);

  if (soldOut) {
    // If already has SOLD OUT tag, do nothing
    if (existingTag && existingTag.classList.contains('sold-out')) {
      return existingTag;
    }
    // Remove any existing discount tag before adding SOLD OUT
    if (existingTag) existingTag.remove();

    const tag = document.createElement('div');
    tag.classList.add('tag', 'sold-out', 'svelte-zhxkdj', 'cs-variant-opt');
    tag.textContent = 'SOLD OUT';
    titleEl.appendChild(tag);
    return tag;
  } else {
    if (discount > 0) {
      // If already has a discount tag, do nothing
      if (existingTag && !existingTag.classList.contains('sold-out')) {
        return existingTag;
      }
      // Remove SOLD OUT tag if present
      if (existingTag) existingTag.remove();

      const tag = document.createElement('div');
      tag.classList.add('tag', 'svelte-zhxkdj', 'cs-variant-opt');
      tag.textContent = `${discount}% OFF`;
      titleEl.appendChild(tag);
      return tag;
    } else {
      // No discount: remove tag if it exists
      if (existingTag) existingTag.remove();
      return null;
    }
  }
}

function handleSizeClick(e) {
  const label = e.target.closest('label');
  if (!label) return;

  const inputId = label.getAttribute('for');
  const input = document.getElementById(inputId);
  // console.log('SIZEEE', e.target, label, input);

  toggleSoldOut(label.classList.contains('is-disabled'));
  
  const value = input.value?.toLowerCase();
  if (!value) return;

  const dealHost = document.querySelector('adoric-bundle-mark-one');
  const dealsContent = dealHost?.shadowRoot?.querySelector('.deals-content');
  if (!dealsContent) return;

  const activeDeal = dealsContent.querySelector('[data-checked="true"]');
  if (!activeDeal) return;

  const selects = activeDeal.querySelectorAll('select');
  selects.forEach(select => {
    const matchOption = Array.from(select.options).find(opt => opt.textContent.trim().toLowerCase() === value);
    if (matchOption) {
      select.value = matchOption.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

function removeDuplicateTags(deal) {
  setTimeout(()=> {
    const tags = deal.querySelectorAll('.tag');
    if(tags.length > 1 ){
      tags.forEach(tag => {
        if(tag.classList.contains('cs-variant-opt')) {
          tag.remove();
        }
      })
    }
  }, 10)
}

function handleDealClick(e) {
  if (e.target.closest('select')) return;

  const dealHost = document.querySelector('adoric-bundle-mark-one');
  const dealsContent = dealHost?.shadowRoot?.querySelector('.deals-content');
  if (!dealsContent) return;

  const activeDeal = dealsContent.querySelector('[data-checked="true"]');
  if (!activeDeal) return;

  removeDuplicateTags(activeDeal);

  const colorSwatch = document.querySelector('.variant-picker__option-values input[type="radio"][name="option1"][id^="swatch"]:checked');
  const sizeSwatch = document.querySelector('.variant-picker__option-values input[type="radio"][name="option2"][id^="swatch"]:checked');

  const selects = activeDeal.querySelectorAll('select');

  selects.forEach(select => {
    const optionsText = Array.from(select.options).map(o => o.textContent.trim().toLowerCase());

    if (colorSwatch && optionsText.includes(colorSwatch.value.toLowerCase())) {
      select.value = colorSwatch.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (sizeSwatch && optionsText.includes(sizeSwatch.value.toLowerCase())) {
      select.value = sizeSwatch.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

const hostObserver = new MutationObserver(() => {
  const dealHost = document.querySelector('adoric-bundle-mark-one');
  const dealsContent = dealHost?.shadowRoot?.querySelector('.deals-content');
  if (!dealsContent) return;
  // Inject CSS on shadow root
  if (!dealHost?.shadowRoot?.querySelector('style[data-variant-tag-style]')) {
    const style = document.createElement('style');
    style.setAttribute('data-variant-tag-style', '');
    style.textContent = `
      .title .tag:not(:first-of-type) {
        display: none;  
      }
    `;
    dealHost?.shadowRoot?.appendChild(style);
  }

  const dealEls = dealsContent.querySelectorAll('.deal-content');
  dealEls.forEach(deal => {
      deal.removeEventListener('click', handleDealClick);
      deal.addEventListener('click', handleDealClick);
  });
  
});

hostObserver.observe(document.body, {
  childList: true,
  subtree: true
});



// capitalize fonts

// (function capitalizeTextContent() {
//   const selectors = [
//     '.template--index #main h1',
//     '.template--index #main .h1',
//     '.template--index #main h2',
//     '.template--index #main .h2',
//     '.template--index #main p.h1',
//     '.template--index #main p.h2',
//     '.template--index #main p.h3',
//     '.template--product #main h1',
//     '.template--product #main .h1',
//     '.template--product #main h2',
//     '.template--product #main .h2',
//     '.template--product #main p.h1',
//     '.template--product #main p.h2',
//     '.template--product #main p.h3',
//   ];

//   console.log('here')
//   selectors.forEach(selector => {
//     document.querySelectorAll(selector).forEach(el => {
//       el.textContent = el.textContent
//         .toLowerCase()
//         .replace(/\b\w/g, c => c.toUpperCase());
//     });
//   });
// })();


class CartRemoveButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();

      const lineItemEl = this.closest('line-item');
      if (!lineItemEl) return;

      const originalRemoveLink = lineItemEl.querySelector('line-item-quantity a[href*="/cart/change"][href*="quantity=0"]');
      if (!originalRemoveLink) {
        console.warn('No matching remove <a> (quantity=0) found inside line-item-quantity');
        return;
      }

      const syntheticClick = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });

      originalRemoveLink.dispatchEvent(syntheticClick);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

